<!--
@create date 2023-6-26
@desc Q302.phomemo.com
-->
<template>
  <div class="guides-div-h831">
    <div class="topText">
      <h1>Download for Phomemo Q302 Portable Printer</h1>
    </div>
    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 30%;margin-bottom: 50px;" v-show="!isMobile()" /> -->
    <div class="main-contain" style="max-width: 1450px">
      <!--     phone -->
      <div class="item-margin" v-show="isMobile()">
        <div style="margin-bottom: 40px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'Q302_appDownload' });
                window.open('https://downloadapp.qu-in.life/MrIn-Phomemo/');
              }
            "
            class="a-link"
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="Q302_APPVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m08f_phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>
      <!--     windows -->
      <div class="item-margin">
        <div style="margin-bottom: 16px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'Q302_windowsDrivers' });
                window.open(
                  'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN_EN.zip'
                );
              }
            "
            class="a-link"
            >Driver for Windows</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="Q302_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>

      <div class="item-margin">
        <div style="margin-bottom: 12px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'Q302_ARMDrivers' });
                window.open(
                  'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN-ARM_EN.zip'
                );
              }
            "
            class="a-link"
            style="line-height: 26px; font-size: 16px"
            >Driver for Windows(ARM)</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="Q302_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>

      <!--     mac -->
      <div class="item-margin">
        <div style="margin-bottom: 20px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'Q302_macDrivers' });
                window.open(
                  'https://oss.qu-in.club/Tianyi/QY_Printer_Driver_MAC_EN.zip'
                );
              }
            "
            class="a-link"
            >Driver for Mac</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 88%"
            id="Q302_macVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_mac_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!-- Linux -->
      <div class="item-margin">
        <div style="margin-bottom: 12px">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/pm246sLinux.png?v=1688530177"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              height: 110px;
            "
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer-Linux.tar.gz"
            class="a-link"
            >Driver for Linux</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/others/q302_pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     phone -->
      <div class="item-margin" v-show="!isMobile()">
        <div style="margin-bottom: 24px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'Q302_appDownload' });
                window.open('https://downloadapp.qu-in.life/MrIn-Phomemo/');
              }
            "
            class="a-link"
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="Q302_APPVideo_2"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m08f_phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <!-- Driver for Chrome -->
      <div class="item-margin" style="min-height: 344px">
        <div style="margin-bottom: 16px">
          <img
            src="https://pages.phomemo.com/resources/chromeIcon.png"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              margin-bottom: 23px;
            "
          />
          <a
            href="https://chromewebstore.google.com/search/Labelife?hl=zh-CN&utm_source=ext_sidebar"
            class="a-link"
            target="_blank"
            >Driver for ChromeOS</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 78%"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/others/Q302_ChormeOS.mp4"
              type="video/mp4"
            />
            Your browser does not support HTML5 video tags.
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
    </div>
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 54%; margin-bottom: 40px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-bottom: 40px"
      v-show="isMobile()"
    />
    <div class="customService" style="margin-top: 10px">
      <h1>Quick Start Guide</h1>
      <div>
        <a
          style="color: #1fc3ff; text-decoration: auto; cursor: pointer"
          @click="
            () => {
              refreshRecord({ key: 'Q302_quickStartGuide' });
              window.open('https://pages.phomemo.com/resources/Q302.pdf');
            }
          "
          target="_blank"
          >Click Here for A Quick Start Guide</a
        >
      </div>
    </div>
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 54%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="!isMobile()"
    />
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 100%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="isMobile()"
    />
    <!--   <div class="faq-content-area">
    <h1 style="margin-bottom: 33px;margin-top: 30px;text-align:center;">Frequently Asked Questions</h1>
    <div class="faq-container">
      <div class="faq-item" v-for="(item, index) in faqDataApp">
        <div class="faq-title" @click="clickQuestion2(item, index)">
          <span v-text="item.title"></span>
          <img src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187" class="downArrow" v-show="activeQuestion2.index === index" />
          <img src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168" class="downArrow" v-show="activeQuestion2.index !== index" />
        </div>
        <div class="faq-scroll-area">
          <div class="faq-content" v-show="activeQuestion2.index === index" v-for="child in item.details">
            <div class="content-title" v-text="child.theme">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 54%;margin-top: 30px;" v-show="!isMobile()" />
  <hr style="color: rgba(51, 61, 71,0.3);width: 100%;margin-top: 30px;" v-show="isMobile()" /> -->
    <div class="customService">
      <h1>Customer Service</h1>
      <div class="everyRow">
        Email：<a
          style="cursor: pointer"
          @click="
            () => {
              refreshRecord({ key: 'Q302_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">Whatsapp：+44 7355 725440</div>
    </div>
  </div>
</template>

<script>
const domainApp = "https://doc.labelife.net/upload/video/omezizy/faqImg/app/";
const faqDataApp = [
  {
    title: "1. Why does the M08F printer keep printing blank paper?",
    details: [
      {
        theme:
          "Firstly, please check whether the printing paper you are using is thermal paper. Regular paper cannot be printed with a thermal printer. (You can find compatible thermal paper in our store)",
        imgUrls: [domainApp + "1.png"],
      },
      {
        theme:
          "Secondly, if you are using the thermal paper we provide, please check if you have reversed the front and back. Please follow the instructions marked on the printing paper to feed the paper in the correct direction.",
        imgUrls: [domainApp + "2.png"],
      },
      {
        theme:
          "Finally, please check if the printer is about to run out of power and charge it in time.",
        imgUrls: [domainApp + "3.png"],
      },
    ],
  },
  {
    title: "2. What file formats can be printed?",
    details: [
      {
        theme:
          "The M08F printer can print common document and picture formats, such as WORD, TXT, PDF, JPG, etc. It also supports printing web content.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Does the printer support double-sided printing?",
    details: [
      {
        theme:
          "Since the M08F is a thermal printer, it can only use thermal paper for single-sided printing.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "4. Is regular US letter compatible with the M08F printer?",
    details: [
      {
        // theme: 'Since the M08F is an A4 thermal printer, it can only print on A4 size thermal paper. (You can find compatible thermal paper in our store)',
        theme:
          "M08F portable printer is available in two models, the M08F-Letter (8.5x11in) and the M08F-A4 (8.27x11.69in) . When you print US Letter size documents, please select the M08F-Letter model and the 8.5x11in size thermal paper.",
        imgUrls: [
          domainApp + "4.png",
          domainApp + "5.png",
          domainApp + "6.png",
          domainApp + "7.png",
        ],
      },
    ],
  },
  {
    title: "5. Do I need to replace the ink or ribbon regularly?",
    details: [
      {
        theme:
          "The M08F printer with thermal printing technology does not require additional consumables such as ink and ribbon.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "6. Why can't the M08F printer connect to my phone via Bluetooth?",
    details: [
      {
        theme:
          "Be sure to connect the Bluetooth in the Phomemo App interface and not in the phone settings.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "7. Is the M08F printer connected to a computer wirelessly via Bluetooth?",
    details: [
      {
        theme:
          "The M08F printer can only be connected to a computer with a data cable. And before using it for the first time, please download and install the driver in the computer, otherwise it will not be able to connect normally.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "8. Why did the computer fail to connect to the M08F printer?",
    details: [
      {
        theme:
          "First of all, please check whether the USB cable is connected to the M08F printer and the computer.",
        imgUrls: [],
      },
      {
        theme:
          "Secondly, please check whether the latest version of the driver is installed on your computer (please find the download and installation method of the driver at the top of this page).",
        imgUrls: [],
      },
      {
        theme:
          "Finally, if there is no problem in the above two steps, please restart the computer and try again, or contact our customer service to help you solve the problem.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "9. I have installed the driver, but the printer still won't connect to the computer. How can I solve the problem?",
    details: [
      {
        theme:
          "Please check if the driver you installed corresponds to your computer program, then please download the latest driver from this page and try again.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "10. Is the M08F printer compatible with vellum paper?",
    details: [
      {
        theme:
          "M08F printers mainly use thermal paper, vellum paper is not applicable.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "11. Does ink fade on the paper after time?",
    details: [
      {
        theme:
          "Portable thermal printers use thermal technology to print, and thermal paper is prohibited from exposure to sunlight and high temperatures;",
        imgUrls: [],
      },
      {
        theme:
          "If stored in a dark, dark environment, it can be stored for up to ten years.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "12. Can this use other size paper such as 4x6 thermal shipping labels?",
    details: [
      {
        theme:
          "No. It would only work with A4 or US Letter size thermal paper.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "13. Can you use this for tattoo stencil transfer?",
    details: [
      {
        theme:
          "The Phomemo M08F Portable printer has been tested and can use a computer or App to print the pattern you need, and print it on the tattoo paper.",
        imgUrls: [],
      },
    ],
  },
];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
import { refreshRecord, sensorsRecord } from "@/util.js";
export default {
  name: "P831",
  props: {},
  data() {
    return {
      window,
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      refreshRecord,
      sensorsRecord
    };
  },
  mounted() {
    this.listenVideo("Q302_APPVideo");
    this.listenVideo("Q302_macVideo");
    this.listenVideo("Q302_windowsVideo");
    this.listenVideo("Q302_APPVideo_2");
    sensorsRecord({ key: "Q302_view" }, 1);
    sensorsRecord({ key: "Q302_WebStay" }, 3);
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({
          key: videoId === "Q302_APPVideo_2" ? "Q302_APPVideo" : videoId,
        });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./H831.less" />



// WEBPACK FOOTER //
// src/view/guides/Q302.vue